import * as React from 'react';
import { Page } from '~/components/founding-team/founding-team';

const FoundingTeamPage: React.FC = () => <Page />;

export default FoundingTeamPage;
